import React, { useState, useEffect } from 'react';
import { formatNumber, parseFlexibleNumber } from '../utils/number';

/**
 * Money input with ₺ prefix, right-aligned bold text and locale-aware formatting.
 * The decimal separator follows the user's browser / mobile setting (comma OR dot),
 * and typed input is accepted in either convention (see utils/number.js).
 * `value` is the raw numeric string kept in form state; `onChange(rawString)` fires on edit.
 * While focused the user's raw keystrokes are shown (no cursor jumps); on blur / external
 * recalculation (e.g. price-mode switch) the value is re-formatted.
 */
export default function AmountInput({ value, onChange, placeholder, required, autoFocus, style }) {
  const display = (v) => (v !== '' && v !== null && v !== undefined && !isNaN(Number(v)) ? formatNumber(v) : '');
  const [text, setText] = useState(display(value));
  const [focused, setFocused] = useState(false);

  // Re-sync from external value when not actively editing (mode-switch recalculation)
  useEffect(() => {
    if (!focused) setText(display(value));
  }, [value, focused]);

  const handleChange = (e) => {
    const raw = e.target.value;
    setText(raw);
    const parsed = parseFlexibleNumber(raw);
    onChange(parsed === '' || parsed === '-' ? '' : parsed);
  };

  return (
    <div style={{ position: 'relative' }}>
      <span style={{
        position: 'absolute', left: 10, top: '50%', transform: 'translateY(-50%)',
        color: '#7a9472', fontWeight: 700, pointerEvents: 'none',
      }}>₺</span>
      <input
        type="text"
        inputMode="decimal"
        value={text}
        onChange={handleChange}
        onFocus={() => setFocused(true)}
        onBlur={() => { setFocused(false); setText(display(value)); }}
        placeholder={placeholder || '0,00'}
        required={required}
        autoFocus={autoFocus}
        style={{ textAlign: 'right', fontWeight: 700, paddingLeft: 26, ...style }}
      />
    </div>
  );
}
